/*
 * @Author: 
 * @Date: 2021-01-11 09:30:38
 * @LastEditors: 诺
 * @LastEditTime: 2021-12-29 23:14:11
 * @Description: file content
 * 
 */
// const Mock = require('mockjs');
// import baseFakeData from "./base-fake-data";
export default {
    protocol: "",
    domain: "",
    action: {
        // 页面配置信息 -ui
        getConfig: {
            api: "circle-act-game-lucky/act/page/getConfig",
            method:'get',
            contentType:'json',
            mock: function () {
                return {
                    msg: "success",
                    code: 0,
                    data: {
                        value: "这里是假数据"
                    }
                }
            }
        }
    },
}